import { Stack, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import Markdown from "@/components/markdown/Markdown";

type Properties = {
  grupo: TGruposDiagnostico;
  licenciado: TLicenciado | undefined;
};

/**
 * QuestionarioGrupo
 * @param root0 - properties
 * @param root0.grupo - grupo
 * @returns QuestionarioGrupo
 */
function QuestionarioGrupo({ grupo }: Properties) {
  const isSmMarches = useMediaQuery("(max-width: 48em)");

  return (
    <Stack justify="space-around" align="center" w={isSmMarches ? "100%" : "50%"}>
      <Title ta="center">{grupo.nome}</Title>
      <Markdown text={grupo.descricao} />
    </Stack>
  );
}

export default QuestionarioGrupo;
